import { useEffect } from 'react';

export default (callback, delay) => {
  useEffect(() => {
    if (delay) {
      const id = setInterval(callback, delay);
      return () => clearInterval(id);
    }
  }, [callback, delay]);
};



// WEBPACK FOOTER //
// ./app/hooks/useInterval.js